export default __webpack_public_path__ + "static/media/chairLogo.18c1f888.jpg";